import { render, staticRenderFns } from "./OneColumnText.vue?vue&type=template&id=2e947e13&scoped=true&"
import script from "./OneColumnText.vue?vue&type=script&lang=js&"
export * from "./OneColumnText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e947e13",
  null
  
)

export default component.exports